<template>
  <b-container>
    <b-row>
      <b-col>
        <h1>Über das Medienarchiv</h1>

        <p class="lead">Bis heute wird die Berichterstattung der Medien von Axel Springer über „1968“ und die
          Studentenbewegung kontrovers diskutiert. Nicht selten geschieht dies ohne Kenntnis der Berichte selbst. Mit
          dem Medienarchiv68 will die Axel Springer SE jedem den unkomplizierten Zugriff auf die Originalquellen
          ermöglichen, um sich selbst ein Bild zu machen.
        </p>
        <p>Rund 5.900 Beiträge, Kommentare, Leserbriefe, Karikaturen, Reportagen, Glossen und Interviews aus den Jahren
          1966 bis 1968 zeigen, wie die Redaktionen von Axel Springer über die 68er-Bewegung berichtet haben.</p>
        <p>Von den damaligen Medienangeboten des Unternehmens wurden ausgewertet:</p>
        <br>
        <ul>
          <li>BERLINER MORGENPOST</li>
          <li>BILD Berlin</li>
          <li>B.Z.</li>
          <li>DIE WELT Berlin</li>
          <li>HAMBURGER ABENDBLATT</li>
          <li>WELT am SONNTAG</li>
          <li>BILD am SONNTAG.</li>
        </ul>
        <p>In Ergänzung wurden in die Auswertung aufgenommen: DER TAGESSPIEGEL als eine repräsentative
          bürgerlich-liberale Stimme und der TELEGRAF als ein eher sozialdemokratisch orientiertes Berliner Blatt. Beide
          Zeitungen werden beispielhaft zu ausgewählten Ereignissen zitiert. Die Berichterstattung der Blätter des
          Verlags Axel Springer kann dadurch punktuell mit jener von Konkurrenzzeitungen verglichen werden.</p>
        <p>Der Betrachtungszeitraum erstreckt sich vom Dezember 1966 bis Dezember 1968. Gesucht wurde nach allen
          Artikeln, die sich mit der Studentenbewegung im weitesten Sinne befasst haben. Zur leichteren Erschließung
          einzelner Aspekte wurden die Artikel nach Stichworten wie beispielsweise Schah/Ohnesorg/Kurras,
          Hochschulreform, SDS oder Kommune I unterteilt. Artikel, die sich keinem dieser Stichworte direkt zuordnen
          ließen, sind unter „Sonstiges“ zusammengefasst.</p>
        <p>Die Datenbank enthält neben den Original-Überschriften zusätzlich auch redaktionell bearbeitete
          Inhaltsangaben zu jedem Artikel, die einer Verbesserung der Suchergebnisse dienen. Eine Volltextsuche in den
          Zeitungsartikeln ist derzeit leider noch nicht möglich. Um das Angebot möglichst zeitnah zu starten, wurde die
          dafür erforderliche automatische Texterkennung aufgrund der hohen Fehlerquote und damit langen
          Bearbeitungsdauer zunächst zurückgestellt. Für eine Optimierung der Suchergebnisse ist diese Option aber für
          eine nächste Ausbaustufe geplant.</p>
        <p>Die Sammlung der Artikel und Erstellung der Datenbank erfolgte unter Leitung von Rainer Laabs, Leiter
          Unternehmensarchiv Axel Springer SE.</p>
        <p>Wir haben uns bemüht, möglichst alle relevanten Artikel zu erfassen. Sollten Artikel fehlen,
          <b-link :to="{ name: 'contact' }">freuen wir uns über Hinweise per E-Mail</b-link>.</p>
        <p><b-link :to="{ name: 'archive' }">Suche im Medienarchiv68 starten</b-link></p>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import store from '@/store'

  export default {
    name: 'AboutPage',
    created () {
      store.commit('setBreadcrumb', ['Über das Archiv'])
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/AboutPage.vue